/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-29 17:29:34
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\security\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 获取监管员列表
export function getSecurityList(params) {
  return request({
    url: '/appletAntifake/antifakeList',
    method: 'get',
    params,
    headers: {
      isApplet: true
    }
  })
}

export function getSecurity(params) {
  return request({
    url: '/appletAntifake/wxScanDetail',
    method: 'get',
    params,
    headers: {
      isApplet: true
    }
  })
}
